/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guides_Level_DeepInputs */

const en_guides_level_deep = /** @type {(inputs: Guides_Level_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In depth`)
};

const ko_guides_level_deep = /** @type {(inputs: Guides_Level_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`심화`)
};

const ja_guides_level_deep = /** @type {(inputs: Guides_Level_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`応用`)
};

/**
* | output |
* | --- |
* | "In depth" |
*
* @param {Guides_Level_DeepInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guides_level_deep = /** @type {((inputs?: Guides_Level_DeepInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guides_Level_DeepInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guides_level_deep(inputs)
	if (locale === "ko") return ko_guides_level_deep(inputs)
	return ja_guides_level_deep(inputs)
});